
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/sadhguru-exclusive",
      function () {
        return require("private-next-pages/[region]/[language]/sadhguru-exclusive/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/sadhguru-exclusive"])
      });
    }
  